module.exports = __webpack_public_path__ + "img/rotura.76cbc7c7.svg";